// extracted by mini-css-extract-plugin
export var actions = "DesktopHeader-module--actions--7TL2s";
export var contextualMenu = "DesktopHeader-module--contextualMenu--721J-";
export var contextualMenuContainer = "DesktopHeader-module--contextualMenuContainer--G0HlZ";
export var fixedHeader = "DesktopHeader-module--fixedHeader--WZQhP";
export var fixedHeaderContainer = "DesktopHeader-module--fixedHeaderContainer--WhyGY";
export var limitWidthOnLargeScreens = "DesktopHeader-module--limitWidthOnLargeScreens--kzA45";
export var links = "DesktopHeader-module--links---Wouk";
export var login = "DesktopHeader-module--login--CgfMz";
export var scrolled = "DesktopHeader-module--scrolled--K+yhO";